import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { Grid, withStyles } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import get from 'lodash.get'
import MenuBar from '../components/header/MenuBar'
import Properties from '../components/Properties'
import DetailsModal from '../components/DetailsModal'
import Footer from '../components/Footer'
import FlashMessage from '../components/FlashMessage'
import Map from '../components/map/Map'
import Filters from '../components/Filters'
import * as actions from '../actions'
import * as types from '../constants'
import * as utils from '../utils'
import queryString from 'query-string'

const TABLET_BREAKPOINT = process.env.REACT_APP_TABLET_BREAKPOINT

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: { margin: `${theme.spacing.unit * 2}px 0` },
  filterTitle: {
    fontSize: '27px',
    fontWeight: '500',
    color: '#333645',
  },
  filterSubTitle: {
    fontSize: '18px',
    fontWeight: '500',
    color: '#333645',
    textTransform: 'uppercase',
    padding: '28px 0 20px',
  },
  mapGrid: {
    height: 'calc(100% - (64px + 64px))',
    width: 'calc(100% - 640px)',
    position: 'fixed',
    top: '128px',
    [theme.breakpoints.down('1024')]: {
      width: 'calc(100% - 338px)',
      height: 'calc(100% - (48px + 64px))',
      top: '112px',
    },
    [theme.breakpoints.down('768')]: {
      display: 'none',
    },
  },
  mobileMapGridOpen: {
    height: '80vh',
    marginTop: '64px',
    width: '100%',
  },
  completeWidth: {
    width: '100%',
  },
  itemFilter: {
    width: '320px',
    padding: '0 38px 0 0',
    [theme.breakpoints.down('sm')]: {
      width: '353px',
      position: 'fixed',
      top: '0',
      bottom: '0',
      height: '100%',
      backgroundColor: '#ffffff',
      left: '0',
      padding: '24px 40px',
      zIndex: '9995',
      overflow: 'auto',
      [theme.breakpoints.down('401')]: {
        width: '100%',
        padding: '24px 15px',
      },
    },
  },
  gridPartialWidth: {
    maxWidth: 'calc(100% - 320px)',
    flexBasis: 'calc(100% - 320px)',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      flexBasis: '100%',
    },
  },
  filterOverlay: {
    [theme.breakpoints.up('md')]: {
      display: 'none !important',
    },
  },
  mapAndResultContainer: {
    display: 'block',
  },
  resultparent: {
    width: '640px',
    float: 'right',
    position: 'relative',
    top: '64px',
    padding: '20px',
    minHeight: 'calc(100vh - ( 64px + 64px + 60px ))',
    [theme.breakpoints.down('1024')]: {
      width: '338px',
    },
    [theme.breakpoints.down('768')]: {
      width: '640px',
      float: 'none',
      margin: '0 auto',
    },
    [theme.breakpoints.down('640')]: {
      width: '338px',
    },
    [theme.breakpoints.down('480')]: {
      width: '320px',
      top: '118px',
      marginBottom: '52px',
    },
  },
  mobileMapWrapper: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1200,
  },
})

class PropertiesPage extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    properties: PropTypes.object.isRequired,
    viewPort: PropTypes.object,
  }

  constructor(props) {
    super(props)
    this.state = {
      showDetail: false,
      showMap: false,
      width: window.innerWidth,
    }
  }

  updateURL = () => {
    const { sortBy, sortOrder } = this.props.filters
    const query = queryString.parse(this.props.location.search)
    const searchString = `address=${query.address}&propertyType=${query.propertyType}&homeType=${query.homeType}&numberOfBedrooms=${
      query.numberOfBedrooms
    }&numberOfBath=${query.numberOfBath}&min=${query.min}&max=${query.max}&sortBy=${sortBy}&order=${sortOrder}&minArea=${query.minArea}&maxArea=${
      query.maxArea
    }`
    return searchString
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnMount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.setState({ width: window.innerWidth })
  }

  toggleDetail() {
    const { showDetail } = this.state
    const { history } = this.props
    this.setState({
      showDetail: !showDetail,
    })

    if (showDetail) {
      history.push({
        pathname: `${types.ROUTES_PATH.PROPERTY}`,
        search: `?${this.updateURL()}`,
      })
    }
  }

  toggleMap() {
    const { showMap } = this.state
    this.setState({
      showMap: !showMap,
    })
  }

  componentDidMount() {
    const {
      match: { params },
    } = this.props
    const page = this.props.location.pathname
    utils.trackPage(page)
    if (params.propertyID) {
      const { showDetail } = this.state
      this.setState({
        showDetail: !showDetail,
      })
    }
  }

  componentDidUpdate(prevProps) {
    const { width } = this.state
    const { queryAddress } = this.props
    const prevID = get(prevProps, 'match.params.propertyID', 0)
    const propertyID = get(this.props, 'match.params.propertyID', 0)
    const isResponsive = width < process.env.REACT_APP_TABLET_BREAKPOINT

    if ((isResponsive && prevProps.queryAddress !== queryAddress) || (isResponsive && this.props.statusUpdate !== prevProps.statusUpdate)) {
      this.fetchPropertiesNoMap()
    }

    if (propertyID > 0 && prevID !== propertyID) {
      this.setState({
        showDetail: true,
      })
    }

    // Browser back button handling for modal popup
    window.onpopstate = e => {
      const {
        match: { params },
      } = this.props

      this.setState({ showDetail: !!params.propertyID })
    }
  }

  fetchPropertiesNoMap() {
    const { actions, searchLocation, viewPort } = this.props
    const safeBounds = utils.createSafeBounds({ viewPort, searchLocation })
    const geoRect = {
      w: get(safeBounds, 'sw.lng', parseFloat(process.env.REACT_APP_DEFAULT_LNG)),
      e: get(safeBounds, 'ne.lng', parseFloat(process.env.REACT_APP_DEFAULT_LNG)),
      n: get(safeBounds, 'ne.lat', parseFloat(process.env.REACT_APP_DEFAULT_LAT)),
      s: get(safeBounds, 'sw.lat', parseFloat(process.env.REACT_APP_DEFAULT_LAT)),
    }
    actions.fetchPropertiesFromRect(geoRect)
  }

  updateMapBounds = mapBounds => {
    this.setState({ mapBounds: mapBounds })
  }

  propertyRemoved = id => {}

  handleFlashMessageClick = () => {
    this.props.actions.showSignInModal(true)
  }
  render() {
    const {
      classes,
      match: { params },
      searchLocation,
      filtersVisible,
      viewPort,
    } = this.props

    const { showDetail, showMap, width, mapBounds } = this.state

    const lat = searchLocation.get('lat') || process.env.REACT_APP_DEFAULT_LAT
    const lng = searchLocation.get('lng') || process.env.REACT_APP_DEFAULT_LNG

    //const selectedProperty = this.props.properties.get(params.propertyID) || this.props.similarProperties.get(params.propertyID)

    const center = { lat: parseFloat(lat), lng: parseFloat(lng) }
    const isTabletMapView = width < TABLET_BREAKPOINT && showMap

    return (
      <Grid container>
        <Grid item xs={12}>
          <MenuBar hidePremium={true} withSearchBox />
        </Grid>

        <Grid item xs={12} className={classes.mapAndResult}>
          <Grid container className={classes.mapAndResultContainer}>
            {width >= TABLET_BREAKPOINT && (
              <Grid item className={classes.mapGrid}>
                <Map
                  ref={this.child}
                  center={center}
                  viewPort={viewPort}
                  onMarkerClick={() => this.toggleDetail()}
                  pageType={'home'}
                  searchString={this.updateURL()}
                  mapBoundsUpdate={this.updateMapBounds}
                />
              </Grid>
            )}
            {isTabletMapView && (
              <div className={classes.mobileMapWrapper}>
                <div className="mapCloseBtn">
                  <CloseIcon onClick={() => this.toggleMap()} />
                </div>
                <Map
                  center={this.props.mapCenter}
                  onMarkerClick={() => this.toggleDetail()}
                  pageType={'home'}
                  mobile
                  searchString={this.updateURL()}
                  mapBoundsUpdate={this.updateMapBounds}
                />
              </div>
            )}

            <Grid className={classes.resultparent}>
              <Filters boundsFromMap={mapBounds} showMap={showMap} toggleMap={() => this.toggleMap()} />
              <Grid container>
                <Grid item xs={12} className={filtersVisible ? classes.gridPartialWidth : classes.fullWidth}>
                  {!isTabletMapView && <Properties onSelect={() => this.toggleDetail()} searchString={this.updateURL()} />}
                  <DetailsModal
                    propertyRemoved={id => this.propertyRemoved(id)}
                    open={showDetail}
                    onClose={() => this.toggleDetail()}
                    propertyId={params.propertyID}
                    searchString={this.updateURL()}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Footer map />

        <FlashMessage handleClick={this.handleFlashMessageClick} />
      </Grid>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}
function mapStateToProps(state) {
  return {
    filtersVisible: state.filters.get('visible'),
    propertyTypes: state.filters.get('propertyTypes'),
    filters: state.filters,
    properties: state.properties.get('data'),
    similarProperties: state.similarProperties.get('data'),
    offset: state.properties.get('offset'),
    searchLocation: state.properties.get('loc'),
    viewPort: state.properties.get('viewPort'),
    queryAddress: state.properties.get('queryAddress'),
    mapCenter: state.map.get('center'),
    statusUpdate: state.user.statusUpdate,
  }
}

const propertiesPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertiesPage)

export default withStyles(styles)(withRouter(propertiesPage))



// WEBPACK FOOTER //
// ./src/containers/PropertiesPage.js